import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import FormRegisterDyDB from '../form';
import TableReport from '../dataGrid';
import { useStore } from '../../../app/stores/store';
import './styles.css';

function DataGridWithForm({
  tableWithForm,
  name,
  setIsTableUpdated,
  isTableUpdated,
}: {
  tableWithForm: any;
  name: string;
  setIsTableUpdated: Dispatch<SetStateAction<boolean>>;
  isTableUpdated: boolean;
}) {
  const { RolesAndPermissionsIDStore } = useStore();

  const { rolesIDs } = RolesAndPermissionsIDStore;

  // const [isTableUpdated, setIsTableUpdated] = useState(false);
  // const [form, setForm] = useState({
  //   formMasterId: tableWithForm.formMasterId,
  //   formMasterName: tableWithForm.formMasterName,
  //   formMasterElement: tableWithForm.formMasterElement,
  //   formFlexBasis: tableWithForm.formFlexBasis,
  //   formLinkName: tableWithForm.formLinkName,
  // });
  // const [table, setTable] = useState({
  //   tableMasterId: tableWithForm.tableMasterId,
  //   tableMasterName: tableWithForm.tableMasterName,
  //   tableMasterElement: tableWithForm.tableMasterElement,
  //   tableFlexBasis: tableWithForm.tableFlexBasis,
  //   tableLinkName: tableWithForm.tableLinkName,
  // });
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [mode, setMode] = useState<any>({
    cancel: 1,
    save: 1,
    download: 1,
    edit: 1,
    delete: 1,
  });

  const {
    formMasterId,
    // formMasterName,
    formMasterElement,
    formFlexBasis,
    // formLinkName,
    tableMasterId,
    // tableMasterName,
    tableMasterElement,
    tableFlexBasis,
    tableLinkName,
  } = tableWithForm;

  useEffect(() => {
    setMode({
      cancel: rolesIDs.filter(
        (data) => data.itemId === 'dd_cancel_btn_form_table',
      )?.[0]?.mode,
      save: rolesIDs.filter(
        (data) => data.itemId === 'dd_save_btn_form_table',
      )?.[0]?.mode,
      download: rolesIDs.filter(
        (data) => data.itemId === 'dd_download_btn_form_table',
      )?.[0]?.mode,
      edit: rolesIDs.filter(
        (data) => data.itemId === 'dd_edit_btn_form_table',
      )?.[0]?.mode,
      delete: rolesIDs.filter(
        (data) => data.itemId === 'dd_delete_btn_form_table',
      )?.[0]?.mode,
    });
  }, [rolesIDs]);

  const rowClickHandler = (data: any) => {
    setSelectedRow(data);
  };

  return (
    <>
      <TableReport
        automaticPdf={false}
        rowSelectedId={selectedRow?.assetId || ''}
        masterId={tableMasterId}
        masterName={name}
        metaData={JSON.parse(tableMasterElement)}
        flexBasis={tableFlexBasis}
        name={name}
        // assetType={data.assetType}
        // elementType={data.elementType}
        isTableUpdated={isTableUpdated}
        setIsTableUpdated={setIsTableUpdated}
        rowClickHandler={rowClickHandler}
        style={{ flexBasis: `${tableFlexBasis}%` }}
        downloadBtnMode={mode.download === undefined ? 1 : mode.download}
        deleteBtnMode={mode.delete === undefined ? 1 : mode.delete}
        editBtnMode={mode.edit === undefined ? 1 : mode.edit}
      />
      <FormRegisterDyDB
        type={'tableWithForm'}
        cancelBtnMode={mode.cancel === undefined ? 1 : mode.cancel}
        submitBtnMode={mode.save === undefined ? 1 : mode.save}
        automaticPdf={false}
        selectedValue={selectedRow[`${tableLinkName}`]}
        linkColumnName={tableLinkName}
        masterId={formMasterId}
        name={name}
        permission={1}
        setIsTableUpdated={setIsTableUpdated}
        index={0}
        metaData={JSON.parse(formMasterElement)}
        style={{ flexBasis: `calc(${formFlexBasis}% - 20px)` }}
      />
    </>
  );
}

export default DataGridWithForm;
